import { queries } from 'RestAPIs/rapini';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import { useColumnDefinitions } from './TreatmentPrograms.utils';

/**
 * The treatment programs (behandelvormen) and whether appointments may be linked to them. Read-only
 * for now: the programs are maintained in the database.
 */
const TreatmentPrograms = () => {
  'use memo';
  const {
    data: treatmentPrograms,
    isLoading,
    isError,
    refetch
  } = queries.useFindTreatmentPrograms();

  const columns = useColumnDefinitions();

  return (
    <TableCRUDLayout
      loading={isLoading}
      columns={columns}
      rows={treatmentPrograms}
      getRowId={(treatmentProgram) => treatmentProgram.id}
      hasLoadingError={isError}
      onLoadingError={refetch}
      hideCreateAction
      editable={false}
      disableActions
    />
  );
};

export default TreatmentPrograms;
